import React from "react";
import { ArrowUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { smoothScrollToTop } from "../../../utils/smoothScroll";
import { useScrolled } from "../../../hooks/useWindowSize";

const ScrollTopButton: React.FC = () => {
  const visible = useScrolled(350);

  // Custom smooth scroll function
  const scrollToTop = () => {
    smoothScrollToTop();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          onClick={scrollToTop}
          initial={{ opacity: 0, scale: 0.7, y: 40 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.7, y: 40 }}
          transition={{ duration: 0.35 }}
          whileHover={{ scale: 1.12 }}
          whileTap={{ scale: 0.95 }}
          className="fixed bottom-6 right-8 sm:bottom-8 sm:right-10 lg:right-12 z-50 group"
          aria-label="Scroll to top"
        >
          {/* Glow Behind Button */}
          <div
            className="absolute inset-0 rounded-full blur-xl opacity-40 group-hover:opacity-75 transition-opacity duration-300"
            style={{ background: `linear-gradient(to right, var(--blue), var(--violet))` }}
          />
          {/* Button face styled with theme-aware navigation background */}
          <div
            className="relative w-12 h-12 flex items-center justify-center rounded-full shadow-2xl transition-all duration-300"
            style={{
              background: "var(--nav-bg)",
              border: "1px solid var(--nav-border)",
              backdropFilter: "blur(20px)",
            }}
          >
            <ArrowUp
              size={22}
              className="transition-all duration-300 group-hover:-translate-y-1"
              style={{ color: "var(--t1)" }}
            />
          </div>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollTopButton;